import gql from 'graphql-tag';

export const SearchLostAndFoundIssueDocument = gql`
  query SearchLostAndFoundIssueDocument($input: LostAndFoundIssueDocumentConnectionInput) {
    searchLostAndFoundIssueDocument {
      lostAndFoundIssueDocumentConnection(input: $input) {
        totalCount
        edges {
          node {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            issueId
            filename
            fileLocation
            contentType
            fileSize
            md5
          }
          cursor
        }
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
      }
    }
  }
`;
